import { InjectionToken, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { RegisterUserComponent } from './register-user/register-user.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { EmailConfirmationComponent } from './email-confirmation/email-confirmation.component';
import { ForgotPasswordSuccessComponent } from './forgot-password-success/forgot-password-success.component';
import { RegisterUserSuccessWithInviteComponent } from './register-user-success-with-invite/register-user-success-with-invite.component';
import { EmailChangeConfirmationComponent } from './email-change-confirmation/email-change-confirmation.component';
import { AGBComponent } from './agb/agb.component';
import { RegisterUserSuccessComponent } from './register-user-success/register-user-success.component';
import { UsedTokenFeedbackComponent } from './used-token-feedback/used-token-feedback.component';
import { WelcomeUserComponent } from './welcome-user/welcome-user.component';
import { ClaimAutochargeIdComponent } from './claim-autochargeId/claim-autochargeId.component';


@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(
      [
        {
          path: 'auth', children: [
            {
              path: 'register',
              component: RegisterUserComponent
            },
            {
              path: 'register-success',
              component: RegisterUserSuccessComponent
            },
            {
              path: 'login',
              component: LoginComponent
            },
            {
              path: 'forgotpassword',
              component: ForgotPasswordComponent
            },
            {
              path: 'forgotpasswordsuccess',
              component: ForgotPasswordSuccessComponent
            },
            {
              path: 'resetpassword',
              component: ResetPasswordComponent
            },
            {
              path: 'emailconfirmation',
              component: EmailConfirmationComponent
            },
            {
              path: 'emailChangeConfirm',
              component: EmailChangeConfirmationComponent
            },
            {
              path: 'agb',
              component: AGBComponent
            },
            {
              path: 'used-token-feedback',
              component: UsedTokenFeedbackComponent
            },
            {
              path: 'register-success-with-invite',
              component: RegisterUserSuccessWithInviteComponent
            },
            {
              path: 'welcome/:key',
              component: WelcomeUserComponent
            },
            {
              path: 'claim-autochargeId',
              component: ClaimAutochargeIdComponent
            }
          ]
        },
      ]
    )
  ],
  providers: [

  ],
})
export class AuthenticationModule { }
